import { api } from '@/lib/api/client';
import type { FeedbackStatus } from '@shared/enums/domain.enum';
import type { CreateFeedbackPayload, Feedback, GetFeedbacksParams } from '@shared/types/entities';

import { buildQuery } from './types';

export interface FeedbackListMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  newCount: number;
}

export async function listFeedbacksApi(
  params?: GetFeedbacksParams,
): Promise<{ data: Feedback[]; meta: FeedbackListMeta }> {
  return api.get(`/feedback${buildQuery(params as Record<string, unknown>)}`);
}

export async function updateFeedbackStatusApi(id: number, status: FeedbackStatus): Promise<Feedback> {
  return api.patch(`/feedback/${id}/status`, { status });
}

/** Envoi d'un feedback depuis le back-office (source ADMIN). */
export async function sendFeedbackApi(
  payload: CreateFeedbackPayload,
): Promise<{ ok: true; id: number; message: string }> {
  return api.post('/feedback', payload);
}
